import LegalPage from '@/components/feature/LegalPage';

const sections = [
  {
    title: '引言',
    paragraphs: [
      '天天漫画（以下简称"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。',
      '本隐私政策适用于天天漫画客户端及网站所提供的各项服务。请您在使用我们的产品或服务前，仔细阅读并了解本政策内容，以保障您的合法权益。',
    ],
  },
  {
    title: '我们如何收集和使用您的个人信息',
    paragraphs: [
      '当您注册天天漫画账号时，我们需要收集您的手机号码或第三方账号信息，用于完成账号的注册与登录。当您使用阅读功能时，我们会收集您的阅读记录、书架收藏等信息，以便为您提供阅读进度同步与个性化推荐服务。',
      '为保障服务的安全与稳定，我们可能会收集您的设备信息（如设备型号、操作系统版本、唯一设备标识符）以及操作日志，用于排查故障、防范安全风险。',
    ],
  },
  {
    title: '我们如何使用 Cookie 和同类技术',
    paragraphs: [
      '为向您提供更便捷的服务，我们会在网站中使用 Cookie 等技术记录您的浏览偏好与登录状态。您可以通过浏览器设置管理或删除 Cookie，但请注意，禁用 Cookie 可能导致部分功能无法正常使用。',
    ],
  },
  {
    title: '我们如何共享、转让、公开披露您的个人信息',
    paragraphs: [
      '我们不会向任何无关第三方出售、出租或共享您的个人信息，除非事先获得您的明确授权。在法律法规允许的范围内，我们可能为提供、维护和改进服务之目的，与合作伙伴共享必要的去标识化信息。',
      '在涉及合并、收购或资产转让等情形时，我们会要求受让方继续受本政策约束，否则将要求其重新征得您的授权同意。',
    ],
  },
  {
    title: '我们如何保护您的个人信息',
    paragraphs: [
      '我们采用业界通行的安全防护措施，包括加密存储、访问控制、数据脱敏等技术手段，保护您的个人信息免受未经授权的访问、使用或泄露。我们也会定期对安全措施进行评估与升级。',
    ],
  },
  {
    title: '您的权利',
    paragraphs: [
      '您有权查询、更正、删除您的个人信息，也可以通过注销账号的方式终止对相关服务的使用。如您对本政策有任何疑问、意见或建议，欢迎通过页面底部的联系邮箱与我们取得联系，我们将在合理期限内予以答复。',
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="隐私政策"
      subtitle="我们重视并致力于保护您的个人信息安全。"
      updatedAt="2026年8月30日"
      sections={sections}
    />
  );
}